import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {Label2, Para} from "@irati/ui/src/Labels/"
import {greys} from "@irati/ui/src/global/colors"
import EmptyCommentsImage from "@irati/ui/images/EmptyComments.svg"

const StyledCopy = styled(Label2)`
  ${Label2};
  color: ${greys.medium};
  text-align: center;
  display: block;
`

const StyledImage = styled.img`
  display: block;
  height: 120px;
  width: 120px;
  margin: 100px auto 20px;
`

class CommentsEmptyState extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: null
  };

  render() {
    const {className} = this.props

    return (
      <div className={className}>
        <StyledImage src={EmptyCommentsImage} alt="default image" />
        <div>
          <Para><StyledCopy>This is the comments feed, where you can view feedback and respond </StyledCopy></Para>
          <StyledCopy>Schedule a survey to start collecting feedback!</StyledCopy>
        </div>
      </div>
    )
  }
}

export default CommentsEmptyState
